module.exports = __webpack_public_path__ + "img/icon3-1-1024x1024.2a90860b.png";